import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { IngredientType } from '@shared/mappers/recipe-translation/recipe-translation.mapper';

@Component({
  selector: 'app-recipes-translation-fields-container',
  templateUrl: './recipes-translation-fields-container.component.html',
  styleUrls: ['./recipes-translation-fields-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf],
})
export class RecipesTranslationFieldsContainerComponent {
  @Input() title: string;
  protected readonly IngredientType = IngredientType;
}
